import { useAuthQuery } from '@rideiq/auth/hooks/useAuthQuery';
import styled from 'styled-components';

import { AdditionalNotesSubsection } from './subsections/AdditionalNotesSubsection';
import { AdvancedRiderNotesSubsection } from './subsections/AdvancedRiderNotesSubsection';
import { CodeWordSubsection } from './subsections/CodeWordSubsection';
import { InRideRecordingSubsection } from './subsections/InRideRecordingSubsection';
import { InRideServicesSubsection } from './subsections/InRideServicesSubsection';
import { SeatOptionsSubsection } from './subsections/SeatOptionsSubsection';
import { useBoosterSeatAutoCheck } from './subsections/useBoosterSeatAutoCheck';
import { useCarSeatAutoCheck } from './subsections/useCarSeatAutoCheck';

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const RiderServicesSection = () => {
  useBoosterSeatAutoCheck();
  useCarSeatAutoCheck();

  const { userFeatures } = useAuthQuery();
  const hidePhi = !!userFeatures?.hidePhi;

  return (
    <Stack>
      <CodeWordSubsection />
      <SeatOptionsSubsection />
      <InRideServicesSubsection />
      <InRideRecordingSubsection />
      {!hidePhi && <AdvancedRiderNotesSubsection />}
      <AdditionalNotesSubsection />
    </Stack>
  );
};
